import { useNavigate } from "react-router-dom";

// funcs
import {
  GenerateCustomerDownload,
  GenerateTierFreightDownload,
} from "../../../funcs/invoicing/GenerateDownload";

// data
import { monthOptions } from "../../../data/collections-data";

// styles and images
import "../../project/Project.css";
import "../AccountInvoices.css";
import Download from "../../../assets/download.svg";
import Mail from "../../../assets/mail.svg";
import BlackDislike from "../../../assets/black-dislike.png";
import BlackLike from "../../../assets/black-like.png";
import DollarSign from "../../../assets/dollar_sign.svg";
import Trash from "../../../assets/delete.svg";

// global
import { accountDataStore, dbDataStore, messageAndErrorStore, userStore } from "../../../store/Store";
import Dates from "../../../components/Dates";

export default function AccountCustomerInvoiceListRows({
  isAsset,
  isTier,
  setBody,
  setTrigger,
  invoices,
  setDeleteTrigger,
  setDeleteId,
  filter,
}) {
  // global
  const accountCustomerInvoiceTotals = accountDataStore(
    (data) => data.accountCustomerInvoiceTotals,
  );

  const companyData = dbDataStore((data) => data.companyData);
  const projectData = dbDataStore((data) => data.projectData);
  const JwtToken = userStore((data) => data.JwtToken);
  const currentUser = userStore((data) => data.currentUser);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  
  const navigate = useNavigate();

  const handleStatus = (s, invoice) => {
    if (s === "Trash") {
      setDeleteTrigger(true);
      setDeleteId(invoice.id);
    } else {
      setBody({
        id: invoice.id,
        invoice_name: invoice.invoice_name,
        invoice_status: s,
        is_asset: invoice.is_asset,
        updated_by_id: currentUser.id,
      });
      setTrigger(true);
    }
  };
  const getMonth = (m) => {
    if (monthOptions.length > 0) {
      let month = monthOptions.filter((x) => x.value === m);
      if (month.length > 0) {
        return month[0].label;
      }
    } else {
      return "";
    }
  };
  const getInvoiceAction = (invoice) => {
    switch (invoice.invoice_status_id) {
      case 25:
        return (
          <img
            className="account-invoice-action"
            src={Mail}
            alt="mail"
            onClick={() => handleStatus(21, invoice)}
          />
        );
      case 21:
        return (
          <>
            <img
              className="account-invoice-action"
              style={{ margin: "0 10px 0 0" }}
              src={BlackLike}
              alt="black-like"
              onClick={() => handleStatus(23, invoice)}
            />{" "}
            <img
              className="account-invoice-action"
              src={BlackDislike}
              alt="black-dislike"
              onClick={() => handleStatus(22, invoice)}
            />
          </>
        );
      case 23:
        return (
          <img
            className="account-invoice-action"
            src={DollarSign}
            onClick={() => handleStatus(24, invoice)}
            alt="dollar-sign"
          />
        );
      case 22:
        return (
          <img
            className="account-invoice-action"
            src={Trash}
            onClick={() => handleStatus("Trash", invoice)}
            alt="trash"
          />
        );
      default:
        return <p></p>;
    }
  };

  const handleDownload = (id) => {
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const requestOptions = {
      method: "GET",
      headers,
      signal: controller.signal,
    };
    fetch(
      `${process.env.REACT_APP_BACKEND}/pc/account-customer-invoices/${id}`,
      requestOptions,
    )
      .then((res) => {
        if (!res.ok) {
          if (res.status === 401) {
            navigate("/login");
            setAuthStatus(false);
          } else {
            toggleNewMessage("Something went wrong");
            return Promise.resolve();
          }
        } else {
          setAuthStatus(true);
          return res.json();
        }
      })
      .then((data) => {
        if (!data) {
          return;
        }
        if (!data.customer_invoice.is_tier) {
          GenerateCustomerDownload(
            data.customer_invoice,
            data.customer_invoice_loads,
            null,
            companyData.filter(
              (x) => x.id === data.customer_invoice.customer_id,
            )[0].company_name,
            projectData,
          );
        } else if (
          !data.customer_invoice.is_asset &&
          data.customer_invoice.is_tier
        ) {
          GenerateTierFreightDownload(
            data.customer_invoice,
            data.customer_invoice_loads,
            companyData.filter(
              (x) => x.id === data.customer_invoice.customer_id,
            )[0].company_name,
          );
        }
      })
      .catch((err) => {
        toggleNewMessage(err);
      });
    return () => controller.abort();
  };

  const handleClick = (id) => {
    navigate(`/account-invoices/customer/${id}`);
  };
  const getTotals = (inv) => {
    var totals = {
      weight: "Closed",
      weight_diff: "Closed",
      rev: "Closed",
      rev_diff: "Closed",
      cost: "Closed",
      cost_diff: "Closed",
    };
    const total = accountCustomerInvoiceTotals.filter(
      (x) => x.invoice_id === inv.id,
    );

    if (total.length > 0) {
      totals.weight = parseFloat(total[0].calculated_weight).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      );
      totals.weight_diff = parseFloat(
        inv.total_weight_tons - total[0].calculated_weight,
      ).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      totals.rev = `$${parseFloat(total[0].calculated_rev).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      )}`;
      totals.rev_diff = `$${parseFloat(
        inv.total_rev - total[0].calculated_rev,
      ).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
      totals.cost = `$${parseFloat(total[0].calculated_cost).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      )}`;
      totals.cost_diff = `$${parseFloat(
        inv.total_cost - total[0].calculated_cost,
      ).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }

    return totals;
  };

  const getCompany = (inv) => {
    if (companyData) {
      var cName = companyData.filter((x) => x.id === inv.customer_id);
      if (cName.length > 0) {
        return cName[0].company_name;
      } else {
        return "";
      }
    }
  };
  return !isAsset && invoices && !isTier ? (
    <>
      {invoices.map(
        (inv, idx) =>
          !inv.is_asset &&
          !inv.is_tier && (
            <tr key={idx}>
              <td
                onClick={() => handleClick(inv.id)}
                style={{ cursor: "pointer" }}
              >
                {inv.invoice_name}
              </td>
              <td>{getCompany(inv)}</td>
              <Dates d={inv.start_date} />
              <Dates d={inv.end_date} />
              {(filter === "approved" || filter === "paid") && (
                <Dates d={inv.approval_date.Time} isApproval={true} />
              )}
              <td>{inv.total_loads}</td>
              <td>
                {parseFloat(inv.total_weight_tons).toLocaleString("en-US")}
              </td>
              <td>{getTotals(inv).weight}</td>
              <td>{getTotals(inv).weight_diff}</td>
              <td>${parseFloat(inv.total_rev).toLocaleString("en-US")}</td>
              <td>{getTotals(inv).rev}</td>
              <td>{getTotals(inv).rev_diff}</td>
              <td>${parseFloat(inv.total_cost).toLocaleString("en-US")}</td>
              <td>{getTotals(inv).cost}</td>
              <td>{getTotals(inv).cost_diff}</td>
              <td>${parseFloat(inv.profit).toLocaleString("en-US")}</td>
              <td>{inv.margin}%</td>
              <td>
                <div className="d-flex">
                  <div className="invoice-action-col">
                    <img
                      className="account-invoice-action"
                      src={Download}
                      alt="download"
                      onClick={() => handleDownload(inv.id)}
                    />
                  </div>
                  {(inv.invoice_status_id === 21 ||
                    inv.invoice_status_id === 23 ||
                    inv.invoice_status_id === 25 ||
                    inv.invoice_status_id === 22) && (
                    <div className="col">{getInvoiceAction(inv)}</div>
                  )}
                </div>
              </td>
            </tr>
          ),
      )}
    </>
  ) : invoices && isAsset && !isTier ? (
    <>
      {invoices.map(
        (inv, idx) =>
          inv.is_asset &&
          !inv.is_tier && (
            <tr key={idx}>
              <td
                onClick={() => handleClick(inv.id)}
                style={{ cursor: "pointer" }}
              >
                {inv.invoice_name}
              </td>
              <td>{getCompany(inv)}</td>
              <Dates d={inv.start_date} />
              <Dates d={inv.end_date} />
              {(filter === "approved" || filter === "paid") && (
                <Dates d={inv.approval_date.Time} isApproval={true} />
              )}
              <td>{inv.total_loads}</td>
              <td>
                {parseFloat(inv.total_weight_tons).toLocaleString("en-US")}
              </td>
              <td>{getTotals(inv).weight}</td>
              <td>{getTotals(inv).weight_diff}</td>
              <td>${parseFloat(inv.total_rev).toLocaleString("en-US")}</td>
              <td>{getTotals(inv).rev}</td>
              <td>{getTotals(inv).rev_diff}</td>
              <td>${parseFloat(inv.total_cost).toLocaleString("en-US")}</td>
              <td>{getTotals(inv).cost}</td>
              <td>{getTotals(inv).cost_diff}</td>
              <td>${parseFloat(inv.profit).toLocaleString("en-US")}</td>
              <td>{inv.margin}%</td>
              <td className="d-flex">
                <div className="invoice-action-col">
                  <img
                    className="account-invoice-action"
                    src={Download}
                    alt="download"
                    onClick={() => handleDownload(inv.id)}
                  />
                </div>
                {(inv.invoice_status_id === 21 ||
                  inv.invoice_status_id === 23 ||
                  inv.invoice_status_id === 25 ||
                  inv.invoice_status_id === 22) && (
                  <div className="col">{getInvoiceAction(inv)}</div>
                )}
              </td>
            </tr>
          ),
      )}
    </>
  ) : (
    invoices &&
    !isAsset &&
    isTier && (
      <>
        {invoices.map(
          (inv, idx) =>
            !inv.is_asset &&
            inv.is_tier && (
              <tr key={idx}>
                <td
                  onClick={() => handleClick(inv.id)}
                  style={{ cursor: "pointer" }}
                >
                  {inv.invoice_name}
                </td>
                <td>{getCompany(inv)}</td>

                <td>{getMonth(inv.tier_month)}</td>
                <td>{inv.tier_year}</td>
                <td>{inv.total_loads.toLocaleString("en-US")}</td>
                <td>
                  {parseFloat(inv.total_weight_tons).toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td>
                  $
                  {parseFloat(inv.total_rev).toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td>
                  {parseFloat(inv.tier_weight_tons).toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td>
                  {parseFloat(inv.billed_weight_tons).toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td className="d-flex">
                  <div className="invoice-action-col">
                    <img
                      className="account-invoice-action"
                      src={Download}
                      alt="download"
                      onClick={() => handleDownload(inv.id)}
                    />
                  </div>
                  {(inv.invoice_status_id === 21 ||
                    inv.invoice_status_id === 23 ||
                    inv.invoice_status_id === 25 ||
                    inv.invoice_status_id === 22) && (
                    <div className="col">{getInvoiceAction(inv)}</div>
                  )}
                </td>
              </tr>
            ),
        )}
      </>
    )
  );
}
